import React, { useRef } from 'react';
import { IonInput } from '@ionic/react';
import '../../styles/authentication/SignupField.scss';

/**
 * SignupField component with floating label inside the input
 * @param {Object} props
 * @param {string} props.label Label text to display inside the input
 * @param {string} props.type Type of input
 * @param {string} [props.value] Value of the input
 * @param {function} props.setter Setter function for the input
 * @param {function} [props.onClick] onClick handler
 * @param {function} [props.onFocus] onFocus handler
 * @param {string} [props.name] Name of input
 * @param {string} [props.placeholder] Placeholder text (optional, for accessibility)
 * @param {boolean} [props.readonly] Readonly flag
 * @returns
 */
function SignupField({ label, type, value, setter, name, readonly, onClick, onFocus, placeholder }) {
  const inputRef = useRef(null);

  return (
    <div className='signup-field-wrapper'>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className='signup-field-label'>{label}</label>
      <IonInput
        className='signup-field-input'
        id='signup-field-input'
        ref={inputRef}
        placeholder={placeholder || ''}
        fill='outline'
        shape='round'
        type={type}
        name={name}
        onInput={event => {
          setter?.(event.target.value);
        }}
        value={value ?? inputRef.current?.value ?? ''}
        readonly={readonly}
        onClick={onClick}
        onFocus={onFocus}
      />
    </div>
  );
}

export default SignupField;
